import http from '../util/http.js'

export function createQuestionnaire(params) {
    return http.post("/admin-api/log/game-interview/create", params)
}